import { cn } from "@heroui/react";
import type { ReactNode } from "react";

export interface ButtonContainerProps {
  /**
   * Button elements to be contained
   */
  children: ReactNode;
  /**
   * Horizontal alignment of buttons. Use "end" for right-aligned layouts. Currently
   * used in dialogs. Also suitable for add buttons in page headers or wizard
   * proceed steps. This pattern is followed for example by GitHub (dialogs
   * use right aligned buttons and full page forms use left aligned buttons).
   */
  align?: "start" | "end";
  className?: string;
}

/**
 * ButtonContainer component that provides consistent layout for button groups
 *
 * - Full width container
 * - Responsive (container @sm): vertical → horizontal layout
 * - Responsive alignment: centered below xs, aligned per align prop at xs and up
 */
export default function ButtonContainer({
  children,
  align = "start",
  className,
}: ButtonContainerProps) {
  return (
    <div
      className={cn(
        "w-full flex flex-wrap justify-center flex-col xs:flex-row gap-3",
        align === "end" ? "justify-end" : "justify-start",
        className,
      )}
    >
      {children}
    </div>
  );
}
